module.exports = __webpack_public_path__ + "static/img/get_purse.726dee6a.png";